export function hexToRGBA(hexString:string,alpha:string | number) {
    
    const red = parseInt(hexString.slice(1, 3), 16),
          green = parseInt(hexString.slice(3, 5), 16),
          blue = parseInt(hexString.slice(5, 7), 16);;

    return alpha ? `rgba(${red},${green},${blue},${alpha})` : `rgb(${red},${green},${blue})`
}

export const compose = (...functions:any) => (x:any) => functions.reduceRight((y:any, f:any) => f(y), x);

export function getRandomInt(min:number = 0, max:number = 10000) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); 
}

export function waitforme(millisec:number) {
    return new Promise(resolve => {
        setTimeout(() => { resolve('') }, millisec);
    })
}

export function precision(number:number, factor:number = 2) {
    return parseFloat(number.toFixed(factor));
}

export function uptilTwoDecimalPlaces(number:any) {
    if(!number) return "0.00";
    if(typeof number !== 'number') return number;
    return number.toFixed(2);
}

var timeout:any;
export function debounce(func:any, time:number = 1000) {
    clearTimeout(timeout);
    timeout = setTimeout(func, time);
}


export function getOrderCode(orderId:string) {
	return orderId.slice(orderId.length - 4);
}